module.exports = __webpack_public_path__ + "img/synopsis-img.2e644d57.jpg";